import * as XLSX from 'xlsx';

import { IPrintingProps } from '@/modules/packhouse/printingOrders/components/GeneralPrintingOrders/PrintingOrderRow/OrdersList/OrderCardContent/Printing';
import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';
interface IProps {
  workerUUID: string;
  instanceUUUID: string;
  entityId?: number;
  companyId?: number;
}
export function generateQRCodeValue({
  entityId,
  instanceUUUID,
  workerUUID,
  companyId,
}: IProps): string {
  // wait 1 millisecond to make sure that the next QRCode will be different
  const start = new Date().getTime();
  while (new Date().getTime() < start + 1);

  const dateNow = Date.now();
  const QRCodeValue = `https://partners.aydi.com/?companyId=${companyId}&entityId=${entityId}&uuid=${instanceUUUID}&workerUUID=${workerUUID}&itemUUID=${dateNow}`;

  return QRCodeValue;
}

interface IGeneratePatchQRCodesDataProps extends IPrintingProps {
  entityId?: number;
  companyId?: number;
}

export function generatePatchQRCodesData({
  orderDetails,
  order,
  entityId,
  supervisor,
  companyId,
}: IGeneratePatchQRCodesDataProps): IPrintingOrders.IGeneratedWorkerQRCodesDataItem[] {
  const result = [];

  if (orderDetails?.workers) {
    for (let i = 0; i < orderDetails.workers.length; i++) {
      const worker = orderDetails.workers[i];
      const instanceUUUID = order.instanceUUUID;

      for (let j = 0; j < orderDetails.numOfTickets; j++) {
        const QRCodeObject = {
          QRCodeValue: generateQRCodeValue({
            workerUUID: worker.workerUUID,
            instanceUUUID: instanceUUUID,
            entityId: entityId,
            companyId: companyId,
          }),
          workerName: worker.workerName,
          workerId: worker?.workerId,
          supervisorName: supervisor?.userName,
        };
        // add divider between workers
        if (j === 0) {
          result.push({
            ...QRCodeObject,
            QRCodeValue: undefined,
            dividerLabel: worker.workerName,
          });
        }
        result.push(QRCodeObject);
      }
    }
  }

  return result;
}

export function handleDownload(
  patchQRCodeData: IPrintingOrders.IGeneratedWorkerQRCodesDataItem[]
) {
  // Create a new workbook
  const wb = XLSX.utils.book_new();

  // Convert patchQRCodeData to a worksheet
  const ws = XLSX.utils.json_to_sheet(patchQRCodeData);

  // Set custom column widths
  ws['!cols'] = patchQRCodeData[0]
    ? Object.keys(patchQRCodeData[0]).map(() => ({ wch: 25 }))
    : [];

  // Set custom height for the header row
  // ws['!rows'] = [{ hpt: 30 }]; // 30 pt height for the first row (header)

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, 'QRCode');

  // Write and export the workbook
  XLSX.writeFile(wb, `${patchQRCodeData[0].supervisorName}_QRCode.xls`);
}
